import { combineReducers } from 'redux';
import { 
  loading,
  login,
  top,
  subject,
  vocabulary,
  chunk,
  userEdit,
  noticeEdit,
  recording,
  recordEdit,
  setting,
  home,
  video,
  error,
 } from './General';

const appReducer = combineReducers({
  loading,
  login,
  top,
  subject,
  vocabulary,
  chunk,
  userEdit,
  noticeEdit,
  recording,
  recordEdit,
  setting,
  home,
  video,
  error,
});

export const blacklist = [
  // 'loading',
  // 'subject',
  // 'userEdit',
  // 'noticeEdit',
  // 'recording',
  // 'recordEdit',
];

//clear all store data
const rootReducer = (state, action) => {
//  if(action.type.indexOf("@@redux") >= 0) return {};
 // if(action.type.indexOf("persist/PERSIST") >= 0) return {};
  //if(action.type.indexOf("persist/REHYDRATE") >= 0) return {};
  return appReducer(state, action);
}

export default rootReducer;